import { render } from "./FormSelectMulti.vue?vue&type=template&id=6cfcae8b"
import script from "./FormSelectMulti.vue?vue&type=script&lang=js"
export * from "./FormSelectMulti.vue?vue&type=script&lang=js"

import "./FormSelectMulti.vue?vue&type=style&index=0&id=6cfcae8b&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__